import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Admincontent2, AdminContext } from '../../../containers/Admin';
import { getAdminClient } from '../AdminApolloClient';
import { gql, useLazyQuery, useMutation } from '@apollo/client';
import { Button } from '../../../ui/button/Button';
import { ButtonGroup } from '../../../ui/button/ButtonGroup';
import { PageContentType } from '../../../../../server/global/enum';
import { H2 } from '../../HeaderTitle';

import { Editor, TopButtonWrapper } from './EditorForm';
import { ImageCard, CardStyle } from './image/ImageCard';
import { ImageForm, ImageData } from './image/ImageForm';
import { checkOfficeTag } from '../../../../utils/helpers/checkOfficeTag';

//images
import { GET_IMAGE, GET_IMAGES } from '../../../../../client/__graphql__/queries/images/getImages';

const client = getAdminClient();

export const EditorImages = (props: {
    urltag: string;
    content_type: any;
    style?: any;
    OnGoToText?: any | null;
}) => {
    const [contentType, setContentType] = useState(props.content_type);
    const [editImage, setEditImage] = useState(false);
    const [listLoading, setListLoading] = useState(true);
    const [image, SetImage] = useState<ImageData>({
        id: 0,
        description: '',
        image: '',
        key: '',
        link: '',
        title: ''
    });

    const [getSingleImage, { data: imgData, error: imgError, loading: imgLoading }] = useLazyQuery(GET_IMAGE,
        {
            fetchPolicy: 'network-only',
            client: client,
            onCompleted: (data: any) => {
                if (data && data?.getImage?.id > 0) {
                    SetImage({
                        id: data.getImage.id,
                        key: data?.getImage?.key,
                        title: data?.getImage?.title,
                        image: data?.getImage?.url,
                        description: data?.getImage?.description,
                        link: data?.getImage?.link_to
                    });
                    setEditImage(true);
                    window.scrollTo({ top: 0, behavior: 'auto' });
                }
            }
        }
    );

    const [getImages, { data: imgList, error: imgListError, loading: imgListLoading }] = useLazyQuery(GET_IMAGES,
        {
            fetchPolicy: 'network-only',
            client: client,
            onCompleted: (data: any) => {
                if (listLoading) {
                    setListLoading(false);
                }
            }
        }
    );

    const GetImageList = () => {
        setListLoading(true);
        getImages({
            variables: {
                input: {
                    is_frontpage: (checkOfficeTag(props.urltag) ? false : true),
                    urltag: checkOfficeTag(props.urltag),
                    type: contentType?.type
                },
            },
        });
        window.scrollTo({ top: 0, behavior: 'auto' });
    };

    const ResetImageList = () => {
        getImages({
            variables: {
                input: {
                    is_frontpage: (checkOfficeTag(props.urltag) ? false : true),
                    urltag: null,
                    type: null
                }
            }
        });
    }

    useEffect(() => {
        GetImageList();
    }, []);

    const OpenImageClick = (e: any) => {
        if (e) {
            getSingleImage({ variables: { input: e } });
            ResetImageList();
        }
    }

    const OpenImageCancel = (e: any) => {
        //e.preventDefault();
        setEditImage(false);
        SetImage({
            id: 0,
            description: '',
            image: '',
            key: '',
            link: '',
            title: ''
        });
        if (imgData?.getImage?.id > 0) {
            getSingleImage({ variables: { input: null } });
        }
        GetImageList();
    }

    const OnUploadNewImage = (e: any) => {
        //e.preventDefault();
        setEditImage(true);
        SetImage({
            id: 0,
            description: '',
            image: '',
            key: '',
            link: '',
            title: ''
        });
        ResetImageList();
    }

    if (editImage) {
        return (<ImageForm image={image} urltag={props.urltag} content_type={contentType} upload={image?.image ? false : true} onCancel={OpenImageCancel} />);
    }

    return (<Admincontent2>
        <H2>Rediger bilder for {contentType?.title}</H2>
        <EditorContainer style={props.style}>
            {props.OnGoToText ?
                <TopButtonWrapper style={{ left: 0 }}  >
                    {props.OnGoToText ?
                        <Button onClick={props.OnGoToText} type="primary" colorTheme="gold">
                            Rediger tekst
                        </Button> : null}
                    <Button type="primary" style={{ cursor: 'auto' }} colorTheme="gray">
                        Rediger bilder
                    </Button>
                </TopButtonWrapper>
                : null}
            {listLoading ? <div><h2>Loading...</h2></div> : null}
            <ImageWrapper >
                <UploadImageBtn onClick={OnUploadNewImage} >
                    <div><h1>Last opp bilde+</h1></div>
                </UploadImageBtn>
                {listLoading ? null :
                    imgList?.getImages?.map((img: any, index: number) => (
                        <ImageCard key={`img_${index}`} imgData={img} onRefresh={GetImageList} onCardClick={OpenImageClick} />
                    ))}
            </ImageWrapper>
        </EditorContainer>
    </Admincontent2 >);
};

const ImageWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  background-color: ${({ theme }) => theme.colors.darkred};
  grid-row-gap: 20px;
  grid-column-gap: 20px;
  padding: 2em;
`;

const UploadImageBtn = styled.div`
    display: flex;
    background-color: ${({ theme }) => theme.colors.darkburgundy};
    color: ${({ theme }) => theme.colors.primary};
    justify-content: center;
    cursor: pointer;

    div {
        margin:auto;
    }

    h1 {
        font-size: 24px;
        text-align: center;
        justify-content: center;
        align-items: center;
    }
`;

const EditorContainer = styled(Editor)`
    width: auto;
    min-width: 800px;
    max-width: 1200px;
`;
